export const pageContent = {
  title: "BEAUTY PIE+",
  header1: {
    line1: "The greatest gift?",
    line2: "Friendship.",
  },
  header2: {
    line1: "The second greatest?",
    line2: "Treating somebody to a Beauty Pie+ membership.",
  },
  price: 59,
  type: "Annual Gift Membership",
  text: {
    line1: "No monthly limits.*",
    line2: "Your friend can shop what they want, when they want.",
  },
  cta: {
    destination: {
      "en-GB": "/basket",
      "en-US": "/basket",
    },
    title: "Buy Now",
    copy: "Buy Now",
  },
  link: "I'm here to redeem my Gift Membership",
}
